'use strict';

/* globals define, document */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/conferences/conferences-list', [], function () {
	var	ConferencesList = {};

	ConferencesList.init = function () {
		$('[data-action="remove-conference"]').click(ConferencesList.removeConference);
	};

    // also used in conference-room
	ConferencesList.removeConference = function () {
        var conferenceId = $(this).attr('data-id');

        bootbox.confirm({
            size: 'small',
            title: '[[conferences:remove-conference]]',
            message: '[[conferences:remove-conference-confirmation]]',
            callback: function (ok) {
                if (ok) {
                    socket.emit('plugins.conferences.removeConference', conferenceId, function (err) {
                        if (err) {
                            return app.alertError(err.message);
                        }
            
                        app.alert({
                            alert_id: 'removed_conference',
                            message: '[[conferences:conference-removed-message]]',
                            type: 'success',
                            timeout: 2000,
                        });
            
                        ajaxify.go('conferences');
                    });
                }
            },
        });
	}

	return ConferencesList;
});
